var map = {
	"./1.jpg.webp": 54,
	"./10.jpg.webp": 55,
	"./11.jpg.webp": 56,
	"./12.jpg.webp": 57,
	"./13.jpg.webp": 58,
	"./14.jpg.webp": 59,
	"./15.jpg.webp": 60,
	"./16.jpg.webp": 61,
	"./17.jpg.webp": 62,
	"./18.jpg.webp": 63,
	"./19.jpg.webp": 64,
	"./2.jpg.webp": 65,
	"./20.jpg.webp": 66,
	"./3.jpg.webp": 67,
	"./4.jpg.webp": 68,
	"./5.jpg.webp": 69,
	"./6.jpg.webp": 70,
	"./7.jpg.webp": 71,
	"./8.jpg.webp": 72,
	"./9.jpg.webp": 73
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;